/** Loom share links in a description body → their embeddable player ids.
 *  Matches `loom.com/share/<id>` (with or without `www`), de-duped, order-kept.
 *  Requires `frame-src https://www.loom.com` in the CSP (see docker/caddy). */
export function extractLoomIds(html?: string | null): string[] {
  if (!html) return [];
  const ids = new Set<string>();
  for (const m of html.matchAll(/https?:\/\/(?:www\.)?loom\.com\/share\/([a-zA-Z0-9]+)/gi)) {
    ids.add(m[1]);
  }
  return [...ids];
}
